<!-- Wrapper Body -->
<div class="wrapper-body">
  <div class="page-header d-flex align-items-center">
    <h3>Completed Appointments</h3>
    <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
    <button type="button" class="theme-button grey mr-md-3 my-3 my-md-0" onclick="exportCSV()">Export to CSV</button>
  </div>
  <div class="content" *ngIf="appointments.length>0">
    <form class="custom-form d-none" [formGroup]="filterForm" id="filterShow">
      <div class="row">
        <div class="col-md-4">
          <input type="text" id="filterSearch" placeholder="Type here to search"
            onkeyup="appointmentFilterFunction()">
        </div>
        <div class="col-md-3">
          <input type="text" formControlName="fromDate" placeholder="From Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
        </div>
        <div class="col-md-3">
          <input type="text" formControlName="toDate" placeholder="To Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
        </div>
        <div class="col-md-2">
          <button type="button" form="intakeForm" fo class="theme-button" id="dateRangeFilter" (click)="submitFilterForm()">Search</button>
        </div>
      </div>
    </form>
    <div class="card" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") && appointments.length>0'>
      <div class="table-responsive">
        <table class="custom-table filterTable" id="appointmentTable">
          <thead>
            <tr class="header">
              <th class="tablewidth">Client Name</th>
              <th>Cell Number</th>
              <th>Email</th>
              <th>Assessment Type</th>
              <th>Appt. Date</th>
              <th>Appt. Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop -->
            <tr *ngFor="let appointment of appointments">
              <td class="tablewidth">{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
              <td>{{appointment.parentDetails.cellNumber}}</td>
              <td>{{appointment.parentDetails.emailAddress}}</td>
              <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
              <td class="">{{appointment.appointmentDetails.schedules[0].appointmentDate}}</td>
              <td class="">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
              <td><a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View Details</a></td>            
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card" *ngIf='userRole=="DIAGNOSTIC" && appointments.length>0'>
      <div class="table-responsive">
        <table class="custom-table" id="appointmentTable">
          <thead>
            <tr class="header">
              <th class="tablewidth" >Client Name</th>
              <th>Cell Number</th>
              <th>Email</th>
              <th>Assessment Type</th>
              <th>Appt. Date</th>
              <th>Appt. Time</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>

            <!-- Loop -->
            <tr *ngFor="let appointment of appointments">
              <td class="tablewidth">{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
              <td>{{appointment.parentDetails.cellNumber}}</td>
              <td>{{appointment.parentDetails.emailAddress}}</td>
              <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
              <td class="">{{appointment.appointmentDetails.schedules[0].appointmentDate}}</td>
              <td class="">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
              <td class="">{{appointment.appointmentDetails.assesmentComments}}</td>
           </tr>

          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="appointments.length<1">
       <div class="row">
        <div class="col-12">
          <div class="card py-5 px-2 text-center">
            <h4 class="text-grey">No Completed Appointments</h4>
            <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="appointments.length<1">
    <div class="row">
      <div class="col-12">
        <div class="card py-5 px-2 text-center">
          <h4 class="text-grey">No Completed Appointments</h4>
          <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="paymentModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="paymentModal" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content light px-5 py-4">
          <h4 class="text-center">Payment</h4>
          <p class="text-green">Total Amount: 1400</p>
          <p class="text-green">Booking Amount Received: 400</p>
          <p class="text-danger">Remaining Amount:1000</p>
          <b class="text-center mt-3">Enter the Payment amount in below input filed</b>
          <input type="number" placeholder="Enter Amount" [(ngModel)]=paymentAmount id="bookingDeposit" class="custom-input mt-3" required>
          <div class="action text-center">
              <button  class="theme-button mx-2" data-dismiss="modal" data-toggle="modal" data-target="#appointmentScheduled" [ngClass]="{'grey' : paymentAmount==undefined}" [disabled]="paymentAmount==undefined" (click)="submitPayment()">Payment Received</button>
              <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">Close</a>
          </div>
      </div>
  </div>
</div>

<div class="modal fade" id="appointmentScheduled" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="appointmentScheduled" aria-hidden="true">
  <div class="modal-dialog">
      <div class="modal-content light px-5 py-4">
          <div class="d-flex">
              <div class="icon">
                  <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
              </div>
              <div class="content">
                  <h4>Payment Received!!</h4>
                  <p>Transaction Id: <span>47346201</span></p>
                 
                  <a  class="theme-button grey" data-dismiss="modal" (click)="redirectHome()">Home</a>
              </div>
          </div>
      </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
  <!-- <p style="color: white">Please Wait... </p> -->
</ngx-spinner>